function getSortedProjectIds () {
  if (!this.projects) return
  const sortedProjects = this.getSortedProjects()
  const sortedProjectIds = sortedProjects.map(project => project.id)
  return sortedProjectIds
}

export default getSortedProjectIds